export class Pair<A, B> {
	private a: A
	private b: B

	constructor(a: A, b: B) {
		this.a = a
		this.b = b
	}

	public getA(): A {
		return this.a
	}

	public getB(): B {
		return this.b
	}

  public toJSON() {
		return { a: this.a, b: this.b }
  }
}

export const pairFromObject = <A, B>(obj: { a: A, b: B }) => new Pair(obj.a, obj.b)